import React, { useEffect, useState } from "react";
import { getNotification } from "../Service/Api";
import { Link } from "react-router-dom";

const Popup = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const getData = async () => {
      const datas = await getNotification();
      setData(datas || []);
    };
    getData();
  }, []);

  useEffect(() => {
    const modalElement = document.getElementById("exampleModalToggle");

    if (modalElement && data.length > 0) {
      modalElement.classList.add("show");
      modalElement.style.display = "block";

      const closeBtn = document.querySelector(".btn-close-white");
      if (closeBtn) {
        closeBtn.addEventListener("click", handleClose);
      }
    }

    return () => {
      const closeBtn = document.querySelector(".btn-close-white");
      if (closeBtn) {
        closeBtn.removeEventListener("click", handleClose);
      }
    };
  }, [data]);

  const handleClose = () => {
    const modalElement = document.getElementById("exampleModalToggle");
    if (modalElement) {
      modalElement.classList.remove("show");
      modalElement.style.display = "none";
    }

    const modalBackdrop = document.querySelector(".modal-backdrop");
    if (modalBackdrop) {
      modalBackdrop.remove();
    }
  };

  return (
    <>
      {data.length > 0 && (
        <div
          className="modal fade"
          id="exampleModalToggle"
          aria-hidden="true"
          aria-labelledby="exampleModalToggleLabel"
          tabIndex="-1"
          style={{ display: "none" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div
                id="modalH"
                className="carousel slide"
                data-bs-ride="carousel"
              >
                <div className="carousel-inner">
                  {data.map((item, index) => (
                    <div
                      key={index}
                      className={`carousel-item ${index === 0 ? "active" : ""
                        }`}
                    >
                      <div className="modal-header">
                        <h1>{item?.title}</h1>
                        <button
                          type="button"
                          className="btn-close btn-close-white"
                          aria-label="Close"
                        ></button>
                      </div>

                      <div className="modal-body">
                        <div className="modalcard">
                          <div className="row">
                            <div className="card-body">
                              {item?.image?.length > 0 && (
                                <img
                                  src={`https://webapi.entab.info/api/image/${item.image[0]}`}
                                  className="img-fluid"
                                  alt="notification"
                                />
                              )}

                              <p>{item?.description}</p>
                              <br />

                              <div className="d-grid gap-2 d-md-flex justify-content-around">
                                {/* Attachment Button */}
                                {item?.attachments?.length > 0 && (
                                  <Link
                                    target="_blank"
                                    to={`https://webapi.entab.info/api/image/${item.attachments[0]}`}
                                    className="btn btn-warning btn-sm"
                                  >
                                    Attachment
                                  </Link>
                                )}

                                {/* URL Button */}
                                {item?.url && (
                                  <Link
                                    target="_blank"
                                    to={item.url}
                                    className="btn btn-warning btn-sm"
                                  >
                                    Click Here
                                  </Link>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                <button
                  className="carousel-control-prev"
                  type="button"
                  data-bs-target="#modalH"
                  data-bs-slide="prev"
                >
                  <span
                    className="carousel-control-prev-icon"
                    aria-hidden="true"
                  ></span>
                  <span className="visually-hidden">
                    Previous
                  </span>
                </button>

                <button
                  className="carousel-control-next"
                  type="button"
                  data-bs-target="#modalH"
                  data-bs-slide="next"
                >
                  <span
                    className="carousel-control-next-icon"
                    aria-hidden="true"
                  ></span>
                  <span className="visually-hidden">
                    Next
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Popup;
